var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"parent"},[_c('div',{staticClass:"parent-side"},[_c('div',[_c('app-row',{attrs:{"title":"نام: ","value":_vm.personnel.Name}}),_c('app-row',{attrs:{"title":"نام خانوادگی: ","value":_vm.personnel.FamilyName}}),(_vm.personnel.Semat)?_c('app-row',{attrs:{"title":"سمت","value":_vm.personnel.Semat}}):_vm._e()],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }